import * as types from '../mutations-types'

const state = {
  showInitDialog: true,
  showFilterApplyHome: false,
  showFilterHome: false,
  filterType: '',
  showCityLayer: false,
  cityLayer: 0

}

const getters = {
  showCityLayer: state => state.showCityLayer,
  cityLayer: state => state.cityLayer,
  showInitDialog: state => state.showInitDialog,
  showFilterApplyHome: state => state.showFilterApplyHome,
  showFilterHome: state => state.showFilterHome,
  filterType: state => state.filterType
}

const actions = {
  displayCitiLayer({commit}, value) {
    // console.log('DISPLAY LAYER ACTION', value)
    commit(types.DISPLAY_CITY_LAYER, value)
  },
  displayApplyFiltersHome({commit}, value) {
    commit(types.DISPLAY_APPLY_FILTERS_HOME, value)
  },
  displayFiltersHome({commit}, value) {
    commit(types.DISPLAY_FILTERS_HOME, value)
  },
  addFilterTypeHome({commit}, value) {
    commit(types.ADD_FILTER_TYPE_HOME, value)
  },
  showInitDialogAction({commit}, value) {
    commit(types.SHOW_INIT_DIALOG, value)
  }
}

const mutations = {
  [types.DISPLAY_CITY_LAYER](state, value) {
    state.cityLayer = value
    state.showCityLayer = value > 0
  },
  [types.SHOW_INIT_DIALOG](state, value) {
    state.showInitDialog = value
  },
  [types.ADD_FILTER_TYPE_HOME](state, value) {
    state.filterType = value
  },
  [types.DISPLAY_FILTERS_HOME](state, value) {
    state.showFilterHome = value
  },
  [types.DISPLAY_APPLY_FILTERS_HOME](state, value) {
    state.showFilterApplyHome = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js